<template>
  <div>
    <div class="footer_app">
      <div class="footer_content">
        <img class="footer_logo" src="@/assets/appimg/common/logo.png" alt="穗盈 / 智慧农业" />
        <p class="footer_slogan">全流程一体化生鲜供应链系统</p>
        <p class="footer_sub_slogan">为食材供应链提供整体数字化可控解决方案</p>
        <img class="footer_qr" src="@/assets/appimg/common/qr.png" alt="穗盈公众号 / 智慧农业服务号" />
        <div class="footer_divider"></div>
        <div class="footer_copyright">
          <p>Copyright © 2026 广州市智慧农业服务股份有限公司 版权所有 All Rights Reserved.</p>
          <p>粤ICP备15101694号-3</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterApp",
  data () {
    return {}
  },
  methods: {
    goUrl(url, id) {
      sessionStorage.setItem(id, id)
      if (sessionStorage.getItem("tabUrl") != url) {
        sessionStorage.setItem('tabUrl', url)
        this.$router.push(url);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/app/components/footer.vue